<script>
import Loader from "@/components/_Shared/Checkout/Payment/_Loader";
import moment from "@/utils/moment";

export default {
  props: {
    success: {
      type: Boolean,
      required: true
    }
  },

  data() {
    return {
      seconds: 90,
      interval: null
    };
  },

  components: {
    Loader
  },

  methods: {
    timeIsOver() {
      return this.seconds === 0;
    },
    emitAndClear() {
      this.$emit("timeout");
      clearInterval(this.interval);
    }
  },

  filters: {
    secondsToTime(seconds) {
      let sec = moment()
        .startOf("day")
        .seconds(seconds);

      return seconds > 59 ? sec.format("m[m] s[s]") : sec.format("s[s]");
    }
  },

  mounted() {
    this.interval = setInterval(() => this.seconds--, 1000);
  },

  watch: {
    seconds() {
      if (this.timeIsOver()) this.emitAndClear();
    }
  }
};
</script>

<template>
  <div class="countdown-timer">
    <loader class="loader" :big="true" :success="success" :is-responsive="false" />
    <div class="timer" :class="{success: success}">
      <small>tempo restante</small>
      {{seconds | secondsToTime}}
    </div>
    <h1>Finalize sua limpeza</h1>
  </div>
</template>

<style scoped>
h1 {
  text-transform: uppercase;
  font-size: 18px;
}

.countdown-timer {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.loader {
  transform: translateY(20px);
}

.timer {
  display: flex;
  flex-direction: column;
  justify-content: center;
  text-align: center;
  transform: translateY(-34px);
  font-weight: bold;
  color: var(--purple);
  font-size: 14px;
}

small {
  font-weight: normal;
  font-size: 9px;
  margin-bottom: 3px;
}

.timer.success {
  color: var(--green);
}

@media (min-width: 768px) {
  .timer {
    transform: translateY(-68px);
    font-size: 24px;
  }

  h1 {
    font-size: 24px;
  }

  small {
    font-size: 12px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/PurchaseFlow/Steps/CheckoutPopup/Countdown.vue